<template>
	<div class="contact">
		<div class="banner">
			<img v-if="inwidth>768" :src="banner" alt="">
			<img v-else :src="phone_pic" alt="">
		</div>
		<div class="content">
			<div class="title" style="display: none;">
				<div class="mytit1">{{mytit.title}}</div>
			</div>
			<div class="map" style="display: none;">
				<div class="mapbox">
					<!-- 百度地图 -->
					<baidu-map v-if="baiduMap" :center="center" :zoom="zoom" @ready="handler" class="lxwm_dt" @click="getClickInfo" :scroll-wheel-zoom='true'>
					</baidu-map>
					<iframe  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3438.846592164391!2d120.16536515109787!3d30.468782981640206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x344ca13b1b5ed4b1%3A0x10b337fb8180d982!2sKano%20Group%20Co.%2C%20Ltd.!5e0!3m2!1sen!2sjp!4v1598420531845!5m2!1sen!2sjp" 
					width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
				</div>
				<div class="address">
					<div class="addtit">{{mytit.company}}</div>
					<div class="addtit1">
						<!-- <img src="../../../static/images/contactaddress.png" alt=""> -->
						<i class="iconfont icon-dizhi"></i>
						<span>{{mytit.address}}</span>
					</div>
					<div class="addtit1 addpic1">
						<!-- <img src="../../../static/images/contactphone.png" alt=""> -->
						<i class="iconfont icon-dianhua2"></i>
						<span>{{mytit.phone}}</span>
					</div>
					<div class="addtit1 addpic2">
						<!-- <img src="../../../static/images/contactemail.png" alt=""> -->
						<i class="iconfont icon-youxiang"></i>
						<span>{{mytit.email}}</span>
					</div>
				</div>
			</div>
			<div class="title">
				<div class="mytit1">Message</div>
				<!-- <div class="mytit2">We welcome your comments and inquiries</div> -->
			</div>
			<div class="form">
				<div class="formlist">
					<div class="inp">
						<span>First&nbsp;Name*</span><input v-model="firstname" type="text">
						<div class="borderft"></div>
						<div class="borderbm"></div>
					</div>
					<div class="inp">
						<span>Last&nbsp;Name*</span><input v-model="lastname" type="text">
						<div class="borderft"></div>
						<div class="borderbm"></div>
					</div>
					<div class="inp"><span>Country*</span>
						<el-select v-model="myCountry" :popper-append-to-body="false" placeholder="Please Select" @change="changeCountry($event)">
							<el-option v-for="item in country" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
						<!-- <select v-model="myCountry" @change="changeCountry($event)">
							<option v-for="(item,index) in country" :value='item'>{{item}}</option>
						</select> -->
						<div class="borderft"></div>
						<div class="borderbm"></div>
					</div>
					<div class="inp">
						<span>Email*</span><input v-model="email" type="text">
						<div class="borderft"></div>
						<div class="borderbm"></div>
					</div>
					<div class="inp">
						<span>City*</span><input v-model="city" type="text">
						<div class="borderft"></div>
						<div class="borderbm"></div>
					</div>
					<div class="inp">
						<span>Phone*</span><input v-model="phone" type="text">
						<div class="borderft"></div>
						<div class="borderbm"></div>
					</div>
					<div class="inp"><span>Topic*</span>
						<el-select v-model="myTopic" :popper-append-to-body="false" placeholder="Please Select" @change="changeData($event)">
							<el-option v-for="item in topic" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
						<!-- <select v-model="myTopic" @change="changeData($event)">
							<option v-for="(item,index) in topic" :value='item'>{{item}}</option>
						</select> -->
						<div class="borderft"></div>
						<div class="borderbm"></div>
					</div>
					<div class="inp inp2">
						<span>Company/Organization*</span><input v-model="company" type="text">
						<div class="borderft"></div>
						<div class="borderbm"></div>
					</div>
				</div>
				<div class="textarea">
					<div class="inp"><span>Message*</span></div>
					<textarea v-model="message"></textarea>
					<div class="checkbox" @click="changeSure">
						<img :src="quanSelected==1?contactgou:contactcha" alt="">
						<span>Subscribe to our newsletter</span>
					</div>
					<div class="btn" @click="send">Send</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: "contact",
		data() {
			return {
				inwidth: window.innerWidth,
				center: {lng: 46.50300, lat:24.39077},
				zoom: 30,
				banner: '',
				mytit: '',
				country: [],
				topic: [],
				firstname: '',
				lastname: '',
				myCountry: '',
				email: '',
				city: '',
				phone: '',
				myTopic: '',
				company: '',
				message: '',
				phone_pic: '',
				quanSelected: 0,
				contactgou:require('../../../static/images/contactgou.png'),
				contactcha:require('../../../static/images/contactcha.png'),
				baiduMap:true,
			}
		},
		created() {
			this.getData()
			var sessionData = sessionStorage.getItem('data');
			console.log(sessionData)
			if (sessionData == null) {
				//判断浏览器的首选语言
				var language = navigator.language;
				if (language == 'zh-CN') {
					sessionStorage.setItem('data', 1);
				} else {
					sessionStorage.setItem('data', 2);
				}
			}
			if(sessionStorage.getItem('data')==1){
				this.baiduMap=true
			}else{
				this.baiduMap=false
			}
		},
		methods: {
			send() {
				var that = this;
				var pattern = /^1[23456789]\d{9}$/;
				if (that.firstname == '') {
					that.$message({
						message: "Please fill in the FirstName",
						type: "warning"
					});
					return false
				} else if (that.lastname == '') {
					that.$message({
						message: "Please fill in the LastName",
						type: "warning"
					});
					return false
				} else if (that.myCountry == '') {
					that.$message({
						message: "Please fill in the Country",
						type: "warning"
					});
					return false
				} else if (that.email == '') {
					that.$message({
						message: "Please fill in the Email",
						type: "warning"
					});
					return false
				} else if (that.city == '') {
					that.$message({
						message: "Please fill in the City",
						type: "warning"
					});
					return false
				} else if (that.phone == '') {
					that.$message({
						message: "Please fill in the Phone",
						type: "warning"
					});
					return false
				} else if (!pattern.test(that.phone)) {
					that.$message({
						message: "Please fill in sure the Phone",
						type: "warning"
					});
				} else if (that.myTopic == '') {
					that.$message({
						message: "Please fill in the Topic",
						type: "warning"
					});
					return false
				} else if (that.company == '') {
					that.$message({
						message: "Please fill in the Company/Organization",
						type: "warning"
					});
					return false
				} else if (that.message == '') {
					that.$message({
						message: "Please fill in the Message",
						type: "warning"
					});
					return false
				}else if(that.quanSelected==0){
					that.$message({
						message: "Please confirm your subscription",
						type: "warning"
					});
					return false
				}else{
				let data = {
					fname: that.firstname,
					lname: that.lastname,
					country: that.myCountry,
					email: that.email,
					city: that.city,
					phone: that.phone,
					topic: that.myTopic,
					company: that.company,
					content: that.message,
				};
				that.$api.online(data).then(res => {
					if (res.status == 1) {
						that.$message({
							message: "Sent successfully",
							type: "success"
						});
					} else {
						that.$message({
							message: res.msg,
							type: "warning"
						});
					}
				});
			  }
			},
			changeCountry(event) {
				this.myCountry = event; //获取ID，即option对应的ID值
			},
			changeData(event) {
				this.myTopic = event; //获取ID，即option对应的ID值
			},
			changeSure() {
				if (this.quanSelected) {
					this.quanSelected = 0
				} else {
					this.quanSelected = 1
				}
			},
			getData() {
				var that = this;
				let data = {};
				that.$api.contact(data).then(res => {
					if (res.status == 1) {
						that.banner = res.data.banner;
						that.phone_pic = res.data.phone_pic;
						that.mytit = res.data.list;
						that.country = res.data.country;
						that.topic = res.data.topic;
					} else {
						that.$message({
							message: res.msg,
							type: "warning"
						});
					}
				});
			},
			handler ({BMap, map}) {
			  var point = new BMap.Point(46.50300,24.39077)
			  var marker = new BMap.Marker(point);  // 创建标注
			  map.addOverlay(marker);              // 将标注添加到地图中
			  map.centerAndZoom(point, 30);
			  var opts = {
			    width : 226,     // 信息窗口宽度
			    height: 70,     // 信息窗口高度
			    title : "迪麦斯" , // 信息窗口标题
			    enableMessage:false,//设置允许信息窗发送短息
			  }
			  var infoWindow = new BMap.InfoWindow("地址：MR2R+VM2 As Sulay, Riyadh", opts);  // 创建信息窗口对象 
			  map.openInfoWindow(infoWindow,point); //开启信息窗口
			  marker.addEventListener("click", function(){          
			    map.openInfoWindow(infoWindow,point); //开启信息窗口
			  });
			},
			getClickInfo (e) {
			  console.log(e.point.lng)
			  console.log(e.point.lat)
			  this.center.lng = e.point.lng
			  this.center.lat = e.point.lat
			},
		}


	}
</script>

<style>
	.contact {
		width: 100%;
		background: #fff;
	}

	.contact .banner {
		width: 100%;
	}

	.contact .banner img {
		width: 100%;
		display: block;
	}

	.contact .content {
		width: 120rem;
		margin: 0 auto;
		padding: 3.0rem 0 5.0rem;
	}

	.contact .title {
		width: 100%;
		padding: 0.6rem 0 2.5rem;
		text-align: center;
		font-size: 3.6rem;
		color: #4c4c4c;
	}

	.contact .title .mytit1 {
		margin-bottom: 0.6rem;
		font-weight: bold;
		letter-spacing: 0.2rem;
	}

	.contact .title .mytit2 {
		font-size: 1.6rem;
		color: #999999;
	}

	.contact .map {
		width: 100%;
		margin-bottom: 7rem;
		position: relative;
	}

	.contact .map .mapbox {
		width: 100%;
		height: 45.0rem;
	}
	.contact .map .mapbox .lxwm_dt{
		width: 100%;
		height: 100%;   
	}
	.contact .map .address {
		width: 29.0rem;
		height: 39rem;
		background: #fff;
		box-sizing: border-box;
		padding: 2.0rem;
		position: absolute;
		top: 8.0rem;
		right: 8%;
		box-shadow: 0px 10px 10px #f5f5f5;
	}

	.contact .address .addtit {
		font-size: 1.8rem;
		color: #333;
		margin-bottom: 1.5rem;
		line-height: 3.2rem;
	}

	.contact .address .addtit1 {
		font-size: 1.4rem;
		color: #333;
		margin-bottom: 2.0rem;
		display: flex;
		line-height: 3.0rem;
	}

	.contact .address .addtit1 span {
		flex: 1;
		line-height: 3.0rem;
	}

	.contact .address .addtit1 i{
		margin-right: 0.8rem;
		line-height: 3.0rem;
	}
	/* .contact .address .addpic1 i {
		margin-top: 0.5rem;
	}
	.contact .address .addpic2 i {
		margin-top: 0.6rem;
	} */

	.contact .formlist {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		margin: auto;
	}

	.formlist .inp {
		width: 31%;
		padding-top: 2rem;
		padding-bottom: 0.5rem;
		margin-right: 3.5%;
		/* border-bottom: 1px solid #e6e6e6; */
		display: flex;
		justify-content: flex-start;
		position: relative;
	}

	.formlist .inp .borderft {
		width: 100%;
		height: 1px;
		background: #e6e6e6;
		position: absolute;
		left: 0;
		bottom: 0;
	}

	.formlist .inp .borderbm {
		width: 0%;
		height: 1px;
		background: #e6e6e6;
		position: absolute;
		left: 0;
		bottom: 0;
		transition: all 1s;
		-moz-transition: all 1s;
		-webkit-transition: all 1s;
	}

	.formlist .inp:hover .borderft {
		display: none;	
	}

	.formlist .inp:hover .borderbm {
		width: 100%;
		background: #333333;
	}

	.formlist .inp2 {
		width: 65.5%;
		margin-right: 0;
	}

	.formlist .inp:nth-child(3n) {
		margin-right: 0;
	}

	.formlist span {
		font-size: 1.6rem;
		color: #333;
		margin-right: 1.2rem;
	}

	.formlist input {
		flex: 1;
		font-size: 1.6rem;
		color: #999;
		border: none;
		background: none;
		outline: none;
		cursor: pointer;
	}

	.formlist .el-select {
		flex: 1;
		font-size: 1.6rem;
		color: #999;
		border: none;
		background: #fff;
		outline: none;
	}

	.formlist .el-select .el-input__inner:focus {
		border: none;
	}

	.formlist .el-select input {
		width: 100%;
		font-size: 1.4rem;
	}

	.formlist .el-select span {
		margin-right: 0rem;
	}

	.formlist .el-input__inner {
		border: none;
		height: 100%;
		line-height: normal;
	}

	.formlist .el-input__icon {
		line-height: normal;
	}

	/* .formlist select {
		width: 70%;
		font-size: 1.6rem;
		color: #999;
		border: none;
		background: #fff;
		outline: none;
		appearance: none;
		-moz-appearance: none;
		-webkit-appearance: none;
		background: url('../../../static/images/contactsele.png') no-repeat scroll right center transparent;
		margin-right: 1rem;
		cursor: pointer;
	}
 */

	.contact .form .textarea {
		padding-top: 2rem;
		margin-bottom: 2.0rem;
	}

	.textarea span {
		font-size: 1.6rem;
		color: #333;
	}

	.textarea textarea {
		width: 100%;
		height: 23rem;
		box-sizing: border-box;
		padding: 1rem;
		margin-top: 0.6rem;
		margin-bottom: 2.0rem;
		line-height: 2.6rem;
		border: 1px solid #e6e6e6;
		background: none;
		outline: none;
		resize: none;
		font-size: 1.6rem;
		color: #999;
		cursor: pointer;
	}

	.textarea .checkbox {
		width: 100%;
		font-size: 1.6rem;
		color: #999;
		text-align: center;
		margin-bottom: 3.0rem;
		cursor: pointer;
	}

	.textarea .checkbox img {
		width: 2.0rem;
		height: 2.0rem;
		margin-right: 1.0rem;
		vertical-align: middle;
	}

	.textarea .btn {
		width: 23.0rem;
		height: 4.5rem;
		margin: auto;
		text-align: center;
		line-height: 4.5rem;
		background: #000000;
		font-size: 1.6rem;
		color: #fff;
		border-radius: 0.4rem;
		cursor: pointer;
	}


	@media(max-width:1200px) {
		.contact .content {
			width: 95%;
		}

		.contact .map .address {
			width: 25.0rem;
			height: 39rem;
		}

		.formlist .inp {
			width: 48%;
			margin-right: 4%;
		}

		.formlist .inp:nth-child(3n) {
			margin-right: 4%;
		}

		.formlist .inp:nth-child(2n) {
			margin-right: 0%;
		}

		.formlist .inp2 {
			width: 48%;
			margin-right: 0;
		}

	}

	@media(max-width:768px) {
		.contact .content {
			width: 85%;
		}

		.contact .banner img {
			height: 40.0rem;
			object-fit: cover;
		}

		.contact .map {
			margin-bottom: 3rem;
		}

		.contact .map .mapbox {
			width: 100%;
			height: 35.0rem;
		}

		.contact .map .address {
			width: 100%;
			height: auto;
			position: static;
			margin-top: 1rem;
		}

		.formlist .inp {
			width: 100%;
			margin-right: 0%;
		}

		.formlist .inp:nth-child(3n) {
			margin-right: 0%;
		}

		.formlist .inp2 {
			width: 100%;
			margin-right: 0;
		}
		.formlist .inp2 input{
			width: 26%;
		}
	}
</style>
